import { Box, ListItemIcon, MenuItem } from '@mui/material';
import React, { useState } from 'react';
import ContainedButton from '../Buttons/ContainedButton';
import { Check, KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import { StyledMenu } from '../Menu/StyledMenu';

const ColorBy = ({ color_by_options, selected_color, update_color_by }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <Box>
      <ContainedButton
        id={`chart-colorby-button`}
        aria-controls={open ? `chart-colorby-menu` : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        disableElevation
        onClick={handleClick}
        endIcon={open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
      >
        Color By - {selected_color}
      </ContainedButton>
      <StyledMenu
        id={`chart-filterer-menu`}
        MenuListProps={{
          'aria-labelledby': `chart-filterer`,
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <Box
          className='bg-slate-400 px-2 py-1 text-xs'
        >
          <code
          >
            NOTE: Changing the color scheme will re-render the chart
          </code>
        </Box>
        {
          color_by_options?.map((color_by, index) => <MenuItem
            key={`${color_by}-${index}-color_by_selector`}
            onClick={(e) => {
              e.stopPropagation();
              if (color_by !== selected_color) {
                update_color_by(color_by);
              }
            }} disableRipple sx={{
              bgcolor: color_by === selected_color ? "#dedede" : ""
            }}>
            <Box className={`flex justify-between w-full uppercase`}>
              <Box>
                {color_by.split("_").join(" ")}
              </Box>
              <Box>
                {color_by === selected_color && <ListItemIcon>
                  <Check />
                </ListItemIcon>}
              </Box>
            </Box>
          </MenuItem>)
        }
      </StyledMenu>
    </Box>
  );
};

export default ColorBy;